import { render, staticRenderFns } from "./performance-statistics.vue?vue&type=template&id=2c8784e2&scoped=true&"
import script from "./performance-statistics.vue?vue&type=script&lang=js&"
export * from "./performance-statistics.vue?vue&type=script&lang=js&"
import style1 from "./performance-statistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8784e2",
  null
  
)

export default component.exports